export const GET_GRADE_LIST = 'GET_GRADE_LIST';
export const GET_SUBJECTS_LIST = 'GET_SUBJECTS_LIST';
export const GET_BOARD_LIST = 'GET_BOARD_LIST';
export const INIT_BOOK_LOADING = 'INIT_BOOK_LOADING';
export const FETCH_BOOKS = 'FETCH_BOOKS';
export const INIT_FETCH_BOOK_DETAIL = 'INIT_FETCH_BOOK_DETAIL';
export const FETCH_BOOK_DETAIL = 'FETCH_BOOK_DETAIL';
export const ADD_ITEM = 'ADD_ITEM';
export const INCREASE_ITEM = 'INCREASE_ITEM';
export const DECREASE_ITEM = 'DECREASE_ITEM';
export const INIT_FILTER_ITEM = 'INIT_FILTER_ITEM';
export const FILTER_ITEM = 'FILTER_ITEM';
export const GET_SELECTED_FILTERS = 'GET_SELECTED_FILTERS';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const INIT_ORDER_BOOK = 'INIT_ORDER_BOOK';
export const USER_SHIPPING_ADDRESS = 'USER_SHIPPING_ADDRESS';
export const ORDER_BOOK = 'ORDER_BOOK';
export const ORDER_BOOKED = 'ORDER_BOOKED';
export const INIT_PAYMENT = 'INIT_PAYMENT';
export const CHECKOUT = 'CHECKOUT';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';
export const INIT_PUBLISH_WITH_US = 'INIT_PUBLISH_WITH_US';
export const PUBLISH_WITH_US = 'PUBLISH_WITH_US';
export const PUBLISH_WITH_US_ERROR_HANDLER = 'PUBLISH_WITH_US_ERROR_HANDLER';
export const INIT_GET_SAMPLE_COPY = 'INIT_GET_SAMPLE_COPY';
export const GET_SAMPLE_COPY = 'GET_SAMPLE_COPY';
export const GET_SAMPLE_COPY_ERROR_HANDLER = 'GET_SAMPLE_COPY_ERROR_HANDLER';
export const GET_BOOK_BY_TYPE = 'GET_BOOK_BY_TYPE';
export const INIT_CHECK_PINCODE = 'INIT_CHECK_PINCODE';
export const CHECK_PINCODE = 'CHECK_PINCODE';
export const INIT_PAGINATION = 'INIT_PAGINATION';
export const PAGINATED_BOOKS = 'PAGINATED_BOOKS';
export const SAVE_PAYLOAD = 'SAVE_PAYLOAD';
export const GET_BOOK_BY_INPUT_TYPE = 'GET_BOOK_BY_INPUT_TYPE';
export const FETCH_GOOGLE_BOOKS = 'FETCH_GOOGLE_BOOKS';

